import * as React from "react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { RowContentCell, CellType } from "@tenforce/toolbox-table-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
    loadMoreLabel: string
    loadMore: () => void
}

export const LoadMore = ({
    loadMoreLabel,
    loadMore,
    ...attrs
}: Props): JSX.Element => (
    <RowContentCell cellProps={{ type: CellType.action }}>
        <Action
            onClick={loadMore}
            actionType={ActionType.block}
            extraClasses="tw-px-3"
            {...attrs}
        >
            <div className="label tw-truncate">
                {Symbols.ExpandDoubleArrowDown}&nbsp;{loadMoreLabel}
            </div>
        </Action>
    </RowContentCell>
)

export default LoadMore
